const paymentMethodLabel = (key, i18n, paymentOptions) => {
  switch (key) {
  case 'paymentRequest': return paymentOptions?.paymentRequest
  case 'credit_card': return i18n.t('payment_methods.card')
  case 'paypal': return 'PayPal'
  case 'venmo': return 'Venmo'
  case 'daf': return 'DAFPay'
  default: return i18n.t(`payment_methods.${key}`)
  }
}

export const paymentMethodTab = (key, i18n) => {
  const method = paymentMethodLabel(key, i18n)
  return {
    children: method,
    'aria-label': i18n.t(`donate_with.${key}`)
    || i18n.t('payment_methods.donate_with', { method })
  }
}

export default paymentMethodLabel
